import Layout from "@/layout/Container.vue"

// 1 超管 2代理账号 3企业账号
export const commonRouter = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: "登录",
    },
    component: () => import("@/views/login")
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: "首页管理",
      icon: require('@/assets/img/nav/1.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'HomeBanner',
        meta: {
          title: '话题管理',
          roles: [1]
        },
        component: () => import("@/views/home/topic")
      },
      {
        path: '/notify',
        name: 'HomeNotify',
        meta: {
          title: '系统通知',
          roles: [1]
        },
        component: () => import("@/views/home/notify")
      },
      {
        path: '/topic',
        name: 'Topic',
        meta: {
          title: 'banner管理',
          roles: [1]
        },
        component: () => import("@/views/home/banner")
      },
    ]
  },
  {
    path: "/school",
    name: "School",
    meta: {
      title: "学校管理",
      icon: require('@/assets/img/nav/2.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/school",
        name: "SchoolList",
        meta: {
          title: '学校列表',
          roles: [1]
        },
        component: () => import("@/views/schoolManage/school/index")
      },
      {
        path: "/faculty",
        name: "FacultyList",
        meta: {
          title: '院系列表',
          roles: [1]
        },
        component: () => import("@/views/schoolManage/faculty/index")
      },
      {
        path: "/major",
        name: "MajorList",
        meta: {
          title: '专业列表',
          roles: [1]
        },
        component: () => import("@/views/schoolManage/major/index")
      },
      {
        path: "/classes",
        name: "ClassesList",
        meta: {
          title: '班级列表',
          roles: [1]
        },
        component: () => import("@/views/schoolManage/classes/index")
      }
    ]
  },
  {
    path: "/company",
    name: "CompanyManage",
    meta: {
      title: "企业管理",
      icon: require('@/assets/img/nav/2.png'),
      Alive: true,
      roles: [1, 3]
    },
    component: Layout,
    children: [
      {
        path: "/company",
        name: "Company",
        meta: {
          title: "企业列表",
          Alive: true,
          roles: [1, 3]
        },
        component: () => import("@/views/company/index")
      },
      {
        path: "/quarters",
        name: "Quarters",
        meta: {
          title: "岗位列表",
          roles: [1, 3]
        },
        component: () => import("@/views/company/quarters/index")
      },
      {
        path: "/account",
        name: "Account",
        meta: {
          title: "账号信息",
          roles: [1, 3]
        },
        component: () => import("@/views/company/account/index")
      }
    ]
  },
  {
    path: "/companyTagList",
    name: "companyTagList",
    meta: {
      title: "企业标签",
      icon: require('@/assets/img/nav/13.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/companyTagList",
        name: "companyTagListDetail",
        meta: {
          title: "企业标签",
          roles: [1]
        },
        component: () => import("@/views/companyTagList/index"),
      }
    ]
  },
  {
    path: "/user",
    name: "UserManage",
    meta: {
      title: "用户管理",
      icon: require('@/assets/img/nav/3.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/user",
        name: "User",
        meta: {
          title: "用户列表",
          Alive: true,
          roles: [1]
        },
        component: () => import("@/views/user/index")
      },
      {
        path: "/recordList",
        name: "RecordList",
        meta: {
          title: "操作记录",
          roles: [1]
        },
        component: () => import("@/views/user/recordList.vue")
      },
      {
        path: "/userInfo",
        name: "UserInfo",
        meta: {
          title: "简历信息",
          roles: [1]
        },
        component: () => import("@/views/user/userInfo.vue")
      }
    ]
  },
  {
    path: "/agent",
    name: "Agent",
    meta: {
      title: "代理管理",
      icon: require('@/assets/img/nav/4.png'),
      roles: [1, 2]
    },
    component: Layout,
    children: [
      {
        path: "/agent",
        name: "AgentList",
        meta: {
          title: '代理列表',
          Alive: true,
          roles: [1, 2]
        },
        component: () => import("@/views/agentManage/agent/index"),
      },
      {
        path: "/agent/salesman",
        name: "salesmanList",
        meta: {
          title: '业务员列表',
          roles: [1, 2]
        },
        component: () => import("@/views/agentManage/salesman/index"),
      },
      {
        path: "/agent/order",
        name: "OrderList",
        meta: {
          title: '交易明细',
          roles: [1, 2]
        },
        component: () => import("@/views/agentManage/order/index"),
      },
      {
        path: "/student/index",
        name: "InviteList",
        meta: {
          title: '邀请明细',
          roles: [1, 2]
        },
        component: () => import("@/views/agentManage/student/index"),
      },
      {
        path: "/student/index1",
        name: "PromoteList",
        meta: {
          title: '推广名单',
          roles: [1, 2]
        },
        component: () => import("@/views/agentManage/student/index1"),
      }
    ]
  },
  {
    path: "/finance",
    name: "Finance",
    meta: {
      title: "提现管理",
      icon: require('@/assets/img/nav/6.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: '/finance',
        name: 'FinanceList',
        meta: {
          title: '财务列表',
          roles: [1]
        },
        component: () => import("@/views/finance/index"),
      },
      {
        path: '/userAllowance',
        name: 'UserAllowance',
        meta: {
          title: '',
          roles: [1]
        },
        component: () => import("@/views/finance/userAllowance"),
      },
      {
        path: '/companyList',
        name: 'companyList',
        meta: {
          title: '',
          roles: [1]
        },
        component: () => import("@/views/finance/company"),
      },
      {
        path: '/studentsWithdraw',
        name: 'studentsWithdraw',
        meta: {
          title: '',
          roles: [1]
        },
        component: () => import("@/views/finance/studentsWithdraw"),
      },
    ]
  },
  {
    path: "/report",
    name: "ReportManage",
    meta: {
      title: "举报管理",
      icon: require('@/assets/img/nav/7.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/report",
        name: "Report",
        meta: {
          title: "举报列表",
          roles: [1]
        },
        component: () => import("@/views/report/index"),
      }
    ]
  },
  {
    path: "/agentJob",
    name: "agentJobManage",
    meta: {
      title: "代招兼职",
      icon: require('@/assets/img/nav/7.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/agentJob",
        name: "agentJob",
        meta: {
          title: "代招兼职",
          roles: [1]
        },
        component: () => import("@/views/agentJob/index"),
      }
    ]
  },
  {
    path: "/partTimeSign",
    name: "partTimeSignManage",
    meta: {
      title: "兼职报名",
      icon: require('@/assets/img/nav/7.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/partTimeSign",
        name: "partTimeSign",
        meta: {
          title: "兼职报名",
          roles: [1]
        },
        component: () => import("@/views/partTimeSign/index"),
      }
    ]
  },
  {
    path: "/degreeCertification",
    name: "degreeCertification",
    meta: {
      title: "学历认证",
      icon: require('@/assets/img/nav/7.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/degreeCertification",
        name: "degreeCertification",
        meta: {
          title: "学历认证",
          roles: [1]
        },
        component: () => import("@/views/degreeCertification/index"),
      }
    ]
  },
  {
    path: "/talentCoinRevenue",
    name: "talentCoinRevenue",
    meta: {
      title: "人才币收益",
      icon: require('@/assets/img/nav/7.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/talentCoinRevenue",
        name: "talentCoinRevenue",
        meta: {
          title: "人才币收益",
          roles: [1]
        },
        component: () => import("@/views/talentCoinRevenue/index"),
      }
    ]
  },
  {
    path: "/platform",
    name: "Platform",
    meta: {
      title: "平台设置",
      icon: require('@/assets/img/nav/5.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/platform",
        name: "PlatformList",
        meta: {
          title: "人才币规则",
          roles: [1]
        },
        component: () => import("@/views/platformRule/index"),
      },
      {
        path: "/brokerage",
        name: "brokerageList",
        meta: {
          title: "佣金规则",
          roles: [1]
        },
        component: () => import("@/views/platformRule/brokerage.vue"),
      },
      {
        path: "/fee",
        name: "feeList",
        meta: {
          title: "会员费",
          roles: [1]
        },
        component: () => import("@/views/platformRule/fee.vue"),
      },
      {
        path: "/rules",
        name: "rulesList",
        meta: {
          title: "就业补贴",
          roles: [1]
        },
        component: () => import("@/views/platformRule/rules.vue"),
      },
      {
        path: "/companyrules",
        name: "CompanyRulesList",
        meta: {
          title: "企业邀请规则",
          roles: [1]
        },
        component: () => import("@/views/platformRule/companyrules.vue"),
      }
    ]
  },
  {
    path: "/feedback",
    name: "FeedbackManage",
    meta: {
      title: "意见反馈",
      icon: require('@/assets/img/nav/8.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/feedback",
        name: "Feedback",
        meta: {
          title: "反馈列表",
          roles: [1]
        },
        component: () => import("@/views/feedback/index"),
      }
    ]
  },
  {
    path: "/jobs",
    name: "JobsManage",
    meta: {
      title: "岗位管理",
      icon: require('@/assets/img/nav/9.png'),
      roles: [1,3]
    },
    component: Layout,
    children: [
      {
        path: "/jobs",
        name: "Jobs",
        meta: {
          title: "岗位列表",
          roles: [1,3]
        },
        component: () => import("@/views/jobs/index"),
      }
    ]
  },
  {
    path: "/resumeManagement",
    name: "resumeManagementManage",
    meta: {
      title: "投递管理",
      icon: require('@/assets/img/nav/9.png'),
      roles: [1,3]
    },
    component: Layout,
    children: [
      {
        path: "/resumeManagement",
        name: "resumeManagement",
        meta: {
          title: "投递管理",
          roles: [1,3]
        },
        component: () => import("@/views/resumeManagement/index"),
      }
    ]
  },
  {
    path: "/weal",
    name: "WealManage",
    meta: {
      title: "福利待遇",
      icon: require('@/assets/img/nav/10.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/weal",
        name: "Weal",
        meta: {
          title: "福利待遇",
          roles: [1]
        },
        component: () => import("@/views/weal/index"),
      }
    ]
  },
  {
    path: "/bond",
    name: "BondManage",
    meta: {
      title: "服务费管理",
      icon: require('@/assets/img/nav/11.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/bond",
        name: "Bond",
        meta: {
          title: "服务费管理",
          roles: [1]
        },
        component: () => import("@/views/bond/index"),
      }
    ]
  },
  {
    path: "/order",
    name: "OrderManage",
    meta: {
      title: "订单管理",
      icon: require('@/assets/img/nav/12.png'),
      roles: [1,3]
    },
    component: Layout,
    children: [
      {
        path: "/order",
        name: "Order",
        meta: {
          title: "订单管理",
          roles: [1,3]
        },
        component: () => import("@/views/order/index"),
      }
    ]
  },
  {
    path: "/invoice",
    name: "InvoiceManage",
    meta: {
      title: "开票管理",
      icon: require('@/assets/img/nav/13.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/invoice",
        name: "invoice",
        meta: {
          title: "开票管理",
          roles: [1]
        },
        component: () => import("@/views/invoice/index"),
      }
    ]
  },
  {
    path: "/edition",
    name: "EditionManage",
    meta: {
      title: "版本管理",
      icon: require('@/assets/img/nav/13.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/edition",
        name: "edition",
        meta: {
          title: "版本管理",
          roles: [1]
        },
        component: () => import("@/views/edition/index"),
      }
    ]
  },
  {
    path: "/share",
    name: "ShareManage",
    meta: {
      title: "邀新活动",
      icon: require('@/assets/img/nav/13.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/share",
        name: "share",
        meta: {
          title: "邀新活动",
          roles: [1]
        },
        component: () => import("@/views/share/index"),
      }
    ]
  },
  {
    path: "/onlineJob",
    name: "onlineJobManage",
    meta: {
      title: "线上招聘会",
      icon: require('@/assets/img/nav/13.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/onlineJob",
        name: "onlineJob",
        meta: {
          title: "线上招聘会",
          roles: [1]
        },
        component: () => import("@/views/onlineJob/index"),
      }
    ]
  },
  {
    path: "/accountList",
    name: "AccountList",
    meta: {
      title: "账号列表",
      icon: require('@/assets/img/nav/13.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/accountList",
        name: "accountListDetail",
        meta: {
          title: "账号列表",
          roles: [1]
        },
        component: () => import("@/views/accountList/index"),
      }
    ]
  },
  {
    path: "/companyAgent",
    name: "CompanyAgent",
    meta: {
      title: "企业代理",
      icon: require('@/assets/img/nav/13.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/companyAgent",
        name: "CompanyAgentList",
        meta: {
          title: "企业代理列表",
          roles: [1]
        },
        component: () => import("@/views/companyAgent/index"),
      }
    ]
  },
  {
    path: "/careerGuidance",
    name: "careerGuidance",
    meta: {
      title: "就业指导",
      icon: require('@/assets/img/nav/13.png'),
      roles: [1]
    },
    component: Layout,
    children: [
      {
        path: "/careerGuidance",
        name: "careerGuidanceList",
        meta: {
          title: "企业代理列表",
          roles: [1]
        },
        component: () => import("@/views/careerGuidance/index"),
      }
    ]
  },
  {
    path: '*',
    name: '404',
    meta: {
      title: '404',
    },
    component: () => import("@/views/404")
  }
]



